export default {"src":"/_next/static/media/mileprogram-earnmile-invite_friends.00c75c68.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};